import { render, staticRenderFns } from "./paid-sick-leave-requests.vue?vue&type=template&id=1de774be&"
import script from "./paid-sick-leave-requests.vue?vue&type=script&lang=js&"
export * from "./paid-sick-leave-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports